/**
 * 设备判断工具函数
 * 结合 userAgent 和 window.innerWidth 判断设备类型
 */

/**
 * 判断是否为移动端设备
 * @returns {boolean} 是否为移动端
 */
export function isMobileDevice(): boolean {
  // 获取 userAgent
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // 移动端设备特征字符串
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

  // 检查 userAgent 是否包含移动端特征
  const isMobileUA = mobileRegex.test(userAgent);

  // 检查屏幕宽度（移动端通常小于 768px）
  const isMobileWidth = window.innerWidth < 768;

  // 两者任一满足即认为是移动端
  return isMobileUA || isMobileWidth;
}

/**
 * 判断是否为 PC 端设备
 * @returns {boolean} 是否为 PC 端
 */
export function isPCDevice(): boolean {
  return !isMobileDevice();
}

